export type ApptStatus = 'booked' | 'confirmed' | 'arrived' | 'in_service' | 'done' | 'no_show' | 'cancelled';
export interface Appointment {
  id: string; customerId: string | null; customerName: string; phone: string | null; staffId: string; resourceId: string | null;
  startsAt: string; endsAt: string; status: ApptStatus; services: { productId: string; description: string; price: string; durationMin: number }[];
  notes: string | null; seriesId: string | null; orderId: string | null; version: number;
}
export interface AgendaStaff { id: string; name: string; color?: string | null; photo?: string | null; schedule?: { day: number; from: string; to: string }[] | null; services?: { productId: string; price: string | null; durationMin: number | null }[] }
export interface AgendaService { id: string; name: string; shortName?: string | null; unitPrice: string; durationMin?: number | null }
export interface AgendaResource { id: string; name: string; kind: string }
export interface NewAppointment {
  customer: { id?: string; name: string; phone: string | null }; staffId: string; resourceId?: string | null; startsAt: string;
  services: { productId: string }[]; durationMin?: number; notes?: string; repeat?: { everyWeeks: number; times: number }; force?: boolean;
}
export interface AgendaPatch { staffId?: string; resourceId?: string | null; startsAt?: string; durationMin?: number; status?: ApptStatus; notes?: string; orderId?: string; force?: boolean }

/** De onde vem e para onde vai a agenda: a gestão (sessão) ou a caixa (terminal, com o operador). */
export interface AgendaClient {
  list(from: string, to: string): Promise<Appointment[]>;
  create(a: NewAppointment): Promise<{ created: Appointment[]; skipped: { startsAt: string; reason: string }[] }>;
  update(id: string, p: AgendaPatch): Promise<Appointment>;
  /** Caixa: um gerente autoriza marcar por cima de outra ou fora do horário. Gestão: já é dono ou gerente. */
  approve?(why: string): Promise<boolean>;
}

export const STATUS_LABEL: Record<ApptStatus, string> = {
  booked: 'Marcada', confirmed: 'Confirmada', arrived: 'Chegou', in_service: 'Em curso', done: 'Concluída', no_show: 'Faltou', cancelled: 'Cancelada',
};
